import { Component, OnInit, Input } from '@angular/core';
import { Subject } from 'rxjs';
import { EmailBatchHistoryTableComponent } from '../../shared/email-batch/email-batch-history-table.component';

@Component({
  selector: 'app-batch-history',
  templateUrl: './batch-history.component.html',
  styleUrls: ['./batch-history.component.scss'],
  standalone: true,
  imports: [EmailBatchHistoryTableComponent]
})
export class BatchHistoryComponent implements OnInit {
  @Input() refreshData!: Subject<boolean>;
  refreshHistoryData = new Subject<boolean>();

  ngOnInit(): void {
    this.refreshData.subscribe(() => {
      this.refreshHistoryData.next(true);
    });
  }
}
